import invoices from "./invoices";
import opensCompleteIdCheckModal from "./opensCompleteIdCheckModal";

export default {
	mixins: [
		invoices,
		opensCompleteIdCheckModal,
	],

	data() {
		return {
			changed: false,
			shake: false,
			disableTaskShake: false,
		};
	},

	methods: {
		shakeTask(delay = 1000, external = true) {
			if (this.disableTaskShake) {
				return;
			}

			if (external) {
				this.disableTaskShake = true;
			}

			setTimeout(() => {
				this.changed = true;
			}, delay);

			setTimeout(() => {
				this.changed = false;
				this.disableTaskShake = false;
			}, delay + 3000);
		},
		triggerTask(task) {
			if (task.complete) {
				return;
			}

			let actions = {
				confirmPersonalDetails: () => {
					this.$vmodal.open({
						component: require("../modals/ConfirmClientDetails").default
					});
				},
				confirmPurchasePropertyAddress: () => {
					this.$vmodal.open({
						component: require("../modals/ConfirmPropertyAddresses").default
					});
				},
				payOutstandingInvoice: () => {
					let invoice = _.first(this.outstandingInvoices);
					let routeObject = {
						name: "invoices.show",
						params: {
							invoice: invoice.id,
						}
					};
					this.$vmodal.close(() => {
						if (!this.$currentRouteMatches(routeObject)) {
							return this.$router.push(routeObject);
						}
					});
				},
				completeIdCheck: () => {
					this.$vmodal.open({
						component: require("../modals/CompleteIdChecks").default
					});
				},
				completeProofOfFunds: () => {
					let instruction = _.find(this.clientGroup.interactiveInstructions, (instruction) => {
						return instruction.proofOfFunds && instruction.proofOfFunds !== "complete";
					});
					let routeObject = {
						name: "instruction.show", params: {
							instruction: instruction.id,
							onMount: "continueProofOfFunds",
						}
					};
					this.$vmodal.close(() => {
						if (!this.$currentRouteMatches(routeObject)) {
							return this.$router.push(routeObject);
						}
						this.refs.proofOfFunds.continueProofOfFunds();
					});
				},
				completeProtocolPack: () => {
					let instruction = _.find(this.clientGroup.interactiveInstructions, (instruction) => {
						return instruction.protocolPack && instruction.protocolPack !== "complete";
					});
					let routeObject = {
						name: "instruction.show", params: {
							instruction: instruction.id,
							onMount: "continueProtocolPack",
						}
					};
					this.$vmodal.close(() => {
						if (!this.$currentRouteMatches(routeObject)) {
							return this.$router.push(routeObject);
						}
						this.refs.protocolPack.continueProtocolPack();
					});
				},
			};

			let action = actions[task.key];

			if (!action) {
				return;
			}

			return actions[task.key]();
		},
		taskClass(task) {
			return {
				"task-list__task--complete": task.complete,
			};
		},
		showNextTaskModal(previousTaskKey = null) {
			this.$vmodal.open({
				component: require("../modals/NextTask").default,
				isDismisable: false,
				props: {
					previousTaskKey: previousTaskKey,
				}
			});
		},
		showClientDetailsModal() {
			this.$vmodal.open({
				component: require("../modals/ConfirmClientDetails").default,
			});
		},
		showPropertyAddressesModal() {
			this.$vmodal.open({
				component: require("../modals/ConfirmPropertyAddresses").default,
			});
		},
	},

	watch: {
		"nextTask.key": {
			handler() {
				this.shakeTask(0, false);
			}
		}
	},
};
